import { useCallback, useEffect, useRef } from "react";

export function useIsMounted(): { isMounted: () => boolean } {
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const isMounted = useCallback(() => isMountedRef.current, []);
  return { isMounted };
}
